import React from "react";
import "./InstructionsModal.css";
import exams from "../../Assets/exam.png";

const InstructionsModal = ({ visible, onClose, onStart, examDuration, subject, instructions = [] }) => {
  if (!visible) return null;

  // Determine actual time per question based on subject
  const fastSubjects = ["mathematics", "physics", "chemistry", "biology"];
  const timePerQuestion = fastSubjects.includes(subject.toLowerCase()) ? 60 : 40;
  const totalTime = examDuration * timePerQuestion / 40;

  // Format seconds into HH:MM:SS
  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
    const s = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="timer-container">
          <img src={exams} alt="Exam illustration" className="exam-image"/>
          <div className="examination-timer-title">{formatTime(totalTime)}</div>
          <div className="examination-timer">{instructions[1]}</div>
        </div>

        <h2 className="modal-title">{instructions[0]}</h2>

        <div className="instructions-content">
          {instructions.slice(3).map((item, index) => (
            <div key={index} className="instruction-item">
              • {item}
            </div>
          ))}
        </div>

        <div className="modal-button-row">
          <button className="start-btn" onClick={onStart}>
            {instructions[2]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstructionsModal;